//-- Copyright (c) 2021 TMT Insights Group, LLC
import TitleDetailMetadata from '@/components/TitleDetail/TitleDetailMetadata/TitleDetailMetadata';
import TitleDetailSynopsis from '@/components/TitleDetail/TitleDetailMetadata/TitleDetailSynopsis';
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Button, Card, CardContent, Grid } from '@mui/material';
import { selectTitleLoading } from '../../../redux/selectors/titleSelectors';
import TabHeading from '../../_common/Tabs/TabHeading';
import { selectJob } from '@/redux/selectors/jobSelectors';
import { useAppSelector } from '@/redux/hooks';
import { parseFns } from '@/redux/selectors/configSelectors';

const JobTabTitleOverview = () => {
  const isLoading = useAppSelector(selectTitleLoading);
  const job = useAppSelector(selectJob);
  const title = job?.title || {};
  const version = job?.version || {};
  const parseDataFn = parseFns.titles?.parseDataFn;

  const buildUrl = () => {
    if (version.program_id) {
      return `/titles/${version.program_id}?tab=metadata&version_id=${version.external_id}`;
    }

    const parsedTitle = parseDataFn ? parseDataFn({ data: [title] })[0] : title;

    const topLevelId = parsedTitle?.lineage?.[parsedTitle.lineage?.length - 2] || parsedTitle.id;
    let url = `/titles/${topLevelId}?tab=metadata`;

    if (parsedTitle.lineage?.length) {
      // if there are 2 items in the lineage array, we can assume they are season and series
      if (parsedTitle.lineage.length === 2) {
        url += `&season_id=${parsedTitle.id}`;
      }
      // if there are 3 items in the lineage array, we can assume they are episode, season, and series
      else if (parsedTitle.lineage.length === 3) {
        url += `&season_id=${parsedTitle.lineage[0]}&episode_id=${parsedTitle.id}`;
      }
    }

    return `${url}&version_id=${version.id}`;
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Card elevation={0}>
          <CardContent>
            <Grid container justifyContent="space-between" alignItems="center" sx={{ position: 'relative' }}>
              <TabHeading icon={<PolarisIcon icon="info" />}>Metadata</TabHeading>
              <TitleRecordButton
                variant="text"
                color="default"
                href={buildUrl()}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<PolarisIcon icon="external_link" style={{ color: 'var(--primary-main)' }} height={15} />}
                disabled={isLoading}
              >
                View Title Record
              </TitleRecordButton>
            </Grid>
            <TitleDetailMetadata disableDropdownOffset />
            <TitleDetailSynopsis />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default JobTabTitleOverview;

const TitleRecordButton = styled(Button)`
  position: absolute;
  font-size: 1rem;
  right: 0;
  top: ${({ theme }) => theme.spacing(-1)};
`;
